export const en = {
	aboutMe: 'about me',
	contact: 'contact'
};